export default __webpack_public_path__ + "static/media/Armguards of the Dauntless.e8f5403a.jpg";